module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "icon icon-menu pull-left open-panel",
    attrs: {
      "data-panel": "#panel-left-menu"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('h1', {
    staticClass: "title header_logo"
  }, [_c('img', {
    staticClass: "lazy",
    attrs: {
      "src": "//img.appfront.fancyecommerce.com/custom/logo.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "icon icon-me open-panel",
    staticStyle: {
      "padding-right": "0.4rem"
    },
    attrs: {
      "data-panel": "#panel-left-account"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "icon icon-cart",
    staticStyle: {
      "padding-right": "0.4rem"
    },
    attrs: {
      "to": "/checkout/cart"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-95071350!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Header.vue
// module id = 264
// module chunks = 1